import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
// Components
import PayFormNew from '../../PayFormNew';
import Box from '../atoms/Box';
import Text from '../atoms/Text';
import Radio from '../atoms/Radio';
import Cards from './Cards';
import CardLogos from '../atoms/CardLogos';
import PayFormNotLoggedIn from '../../PayFormNotLoggedIn';

const Container = styled(Box)`
  border: ${(p) => (p.selected ? `2px solid #5b5ff5` : `1px solid #d7d7d7`)};
  cursor: pointer;
  transition: all 0.25s ease;
  background: #fff;

  &:hover {
    border-color: #5b5ff5;
    box-shadow: 0 2px 8px rgba(91, 95, 245, 0.1);
  }

  input[type='radio'] {
    accent-color: #5b5ff5;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

const CardsCheckout = ({
  cbs,
  _setCard,
  card,
  client,
  stripePayment,
  setStripePayment,
  loading,
  isNotLoggedIn = false,
  clientNotConnected,
  amount,
  giftcard,
  setGiftcard,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {!!cbs.length && (
        <Box my={4}>
          <Cards
            cards={cbs}
            card={card}
            client={client}
            _setCard={_setCard}
            loading={loading}
          />
          <Container
            borderRadius="xs"
            alignItems="center"
            onClick={() => _setCard('__ADD__')}
            selected={card === '__ADD__'}
            p={4}
            mt={3}>
            <Box
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
              width="100%">
              <Text
                style={{
                  fontFamily: 'LTSaeada, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#2e414b',
                  fontSize: '0.95rem',
                }}>
                {t('repaircheckout.card.new')}
              </Text>
              <Radio checked={card === '__ADD__'} />
            </Box>
            {card === '__ADD__' && (
              <Box px={0} my={4} width="100%">
                <PayFormNew
                  stripePayment={stripePayment}
                  setStripePayment={setStripePayment}
                />
              </Box>
            )}
          </Container>
        </Box>
      )}
      {card === '__ADD__' && !cbs.length && !isNotLoggedIn && (
        <Box mb={4}>
          <PayFormNew
            stripePayment={stripePayment}
            setStripePayment={setStripePayment}
          />
        </Box>
      )}
      {isNotLoggedIn && (
        <Box mb={4}>
          <PayFormNotLoggedIn
            stripePayment={stripePayment}
            setStripePayment={setStripePayment}
            clientNotConnected={clientNotConnected}
            amount={amount}
            giftcard={giftcard}
            setGiftcard={setGiftcard}
          />
        </Box>
      )}
      <CardLogos mb={2} />
    </>
  );
};

export default CardsCheckout;
